
/**
 * @imports
 */
import * as QuantumJS from '@webqit/quantum-js/lite';
import init from './init.js';

/**
 * @init
 */
init.call( window, QuantumJS );